import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "@fetch/axios";
import { useTranslation } from "@hooks/useTranslation";
import { LanguageCurrencyContext } from "@context/LanguageCurrencyContext";
import { useAuth } from "@context/AuthContext";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Spinner from "@components/Spinner";

const Component = () => {
  const MySwal = withReactContent(Swal)
  const [name, setName] = useState(localStorage.getItem('guest_checkout_name') || null);
  const [lastname, setLastname] = useState(null);
  const [email, setEmail] = useState(localStorage.getItem('guest_checkout_email') || null);
  const [password, setPassword] = useState(null);
  const [phone, setPhone] = useState(52);
  const [country, setCountry] = useState(142);
  const [date, setDate] = useState(null);
  const { translate } = useTranslation();
  const { lang } = useContext(LanguageCurrencyContext);
  const { setAuthPage } = useAuth();
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true)


  const TogglePassword = (event) => {
    event = event.target;
    event.classList.toggle("icon-EyeClosed");
    event.classList.toggle("icon-EyeOpen");
    event = event.previousElementSibling;
    if (event.toggleAttribute("type")) {
      event.type = "password";
    }
  };


  const getcountries = async (reload = false) => {

    if (!localStorage.getItem('countries_arteonu') || reload) {
      try {
        const response = await axios.get(`/countries?lang=${localStorage.getItem('lang_arteonu')}`);
        localStorage.setItem('countries_arteonu', JSON.stringify(response.data));
        setCountries(response.data)

      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    } else {
      setCountries(JSON.parse(localStorage.getItem('countries_arteonu')))
    }


  }

  useEffect(() => {
    getcountries(true)
  }, [])

  const registrarse = async () => {

    if (!name || !lastname || !email || !password || !phone || !date) {
      MySwal.fire({
        text: translate('error.field'),
        icon: 'error',
        title: 'Oops...'
      })

      return;
    }

    const birthDate = new Date(date);
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    const isBirthdayPassed = m > 0 || (m === 0 && today.getDate() >= birthDate.getDate());
    const realAge = isBirthdayPassed ? age : age - 1;

    if (realAge < 18) {
      MySwal.fire({
        text: translate('login.date_error'),
        icon: 'error',
        title: 'Oops...'
      });
      return;
    }

    try 
    {
      setLoading(false)
      localStorage.setItem('continuar_comprando_arteonu',window.location.pathname)
      const res = await axios.post(
        "/users/register",
        {
          "name": name,
          "lastname": lastname,
          "date_birth": date,
          "country_id": country,
          "phone": phone,
          "email": email,
          "password": password,
          "lang": lang,
          "cart": JSON.parse(localStorage.getItem('cart') ?? '[]')
        }
      );

      setLoading(true)
      if (res.data.errors) {

        MySwal.fire({
          text: res.data.message,
          icon: 'error',
          title: 'Oops...'
        })

      } else {
        localStorage.setItem('token_volver_crear', res.data.token)
        localStorage.setItem('email_crear', email)
        setAuthPage('ConfirmarRegistro')

        //MySwal.fire({
        //   text: translate('login.create'),
        //   icon: 'success',
        // })

      }
    } catch (error) {
      setLoading(true)

      MySwal.fire({
        text: error.response.data.message,
        icon: 'error',
      })

    }

  }

  return (
    <>
      {!loading && <Spinner />}

      <div className="Row">

        <label className="FormData">
          <em className="RequiredData">{translate('login.name')}</em>
          <div className="FormInputLight">
            <input placeholder={translate('login.nameplacesholder')} onChange={(e) => { setName(e.target.value) }} value={name || ''} />
          </div>
        </label>

        <label className="FormData">
          <em className="RequiredData">{translate('login.lastname')}</em>
          <div className="FormInputLight">
            <input placeholder={translate('login.lastnameplacesholder')} onChange={(e) => { setLastname(e.target.value) }} />
          </div>
        </label>

      </div>

      <div className="Row">


        <label className="FormData">
          <em className="RequiredData">{translate('login.date')}</em>
          <div className="FormInputLight">
            <input type="date" placeholder={translate('login.date')} onChange={(e) => { setDate(e.target.value) }} />
          </div>
        </label>

      </div>

      <div className="Row">
        <label className="FormData">
          <em className="RequiredData">{translate('login.country')}</em>
          <div className="FormInputLight">
            <select onChange={(e) => {
              const selectedCountryId = parseInt(e.target.value, 10); // Parse to integer
              const selectedCountry = countries.find(country => country.id == selectedCountryId);
              if (selectedCountry) {
                setCountry(selectedCountry.id); // Assuming you still want to set the country ID
                setPhone(selectedCountry.phone_code);
              }
            }}>
              {countries &&
                countries.map((pais) => (
                  <option key={pais.id} value={pais.id}
                    selected={country && pais.id == 142} >
                    {pais.name}
                  </option>
                ))}
            </select>
            <i className="InputIcon icon-Select"></i>
          </div>
        </label>
        <label className="FormData">
          <em className="RequiredData">{translate('login.phone')}</em>
          <div className="FormInputLight">
            <input placeholder="5500000000" onChange={(e) => { setPhone(e.target.value) }} value={phone} />
          </div>
        </label>
      </div>

      <label className="FormData">
        <em className="RequiredData">{translate('login.email')}</em>
        <div className="FormInputLight">
          <input placeholder={translate('login.email')} onChange={(e) => { setEmail(e.target.value) }}  value={email}/>
        </div>
      </label>

      <label className="FormData">
        <em className="RequiredData">{translate('login.password')}</em>
        <div className="FormInputLight">
          <input placeholder={translate('login.password')} type="password" onChange={(e) => { setPassword(e.target.value) }} />
          <i className="InputIcon icon-EyeClosed" onClick={TogglePassword}></i>
        </div>
      </label>

      <div className="TextColorSec">
        {translate('login.term1')} <Link to="/404">"{translate('login.term2')}"</Link>, <Link to="/404">"{translate('login.term3')}"</Link>, <Link to="/404">"{translate('login.term4')}"</Link> y <Link to="/404">"{translate('login.term5')}"</Link>, {translate('login.term6')} <Link to="/404">"{translate('login.term7')}"</Link>.
      </div>

      <div className="TextColorSec">
        <p>{translate('login.check_spam')}</p>
      </div>

      <div
        className="ButtonLightMedium"
        onClick={() => registrarse()}
      >
        {translate('login.registerM')}
        <i className="icon-ArrowRight"></i>
      </div>

      <div>
        <p>{translate('login.already_account')}</p>
        <a onClick={() => setAuthPage('IniciarSesionWith')} style={{ cursor: 'pointer' }}>
          <b>{translate('login.title')}</b>
        </a>
      </div>

      <div className="TextColorSec">
        <em>{translate('login.forgout')} </em>
        <a onClick={() => setAuthPage('RestablecerPassword')} style={{ cursor: 'pointer' }}>
          <b>{translate('recovery.title')} </b>
        </a>
      </div>
    </>
  );
};

export default Component;
